import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Menu, X, Globe } from 'lucide-react';

const Header = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: t.nav.home, path: language === 'es' ? '/' : '/en' },
    { name: t.nav.about, path: language === 'es' ? '/sobre-nosotros' : '/en/about' },
    { name: t.nav.projects, path: language === 'es' ? '/promociones' : '/en/projects' },
    { name: t.nav.contact, path: language === 'es' ? '/contacto' : '/en/contact' }
  ];

  const isActive = (path) => {
    if (path === '/' || path === '/en') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to={language === 'es' ? '/' : '/en'} className="flex items-center space-x-3" data-testid="logo-link">
            <img 
              src="/logo_transparent.png" 
              alt="PASTORIA SERRALTA" 
              className="h-20 w-auto"
              data-testid="logo-image"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium transition-colors hover:text-[#356C8A] ${
                  isActive(item.path) ? 'text-[#356C8A]' : 'text-gray-700'
                }`}
                data-testid={`nav-link-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {item.name}
              </Link>
            ))}
            
            <button
              onClick={toggleLanguage}
              className="flex items-center space-x-1 px-3 py-2 rounded-lg bg-[#E8F2F7] text-[#356C8A] hover:bg-[#C5DEE8] transition-colors text-sm font-medium"
              data-testid="language-toggle"
            >
              <Globe className="h-4 w-4" />
              <span>{language.toUpperCase()}</span>
            </button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <button
              onClick={toggleLanguage}
              className="p-2 rounded-lg bg-[#E8F2F7] text-[#356C8A]"
              data-testid="mobile-language-toggle"
            >
              <Globe className="h-5 w-5" />
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 rounded-lg text-gray-700 hover:bg-[#E8F2F7] transition-colors"
              data-testid="mobile-menu-button"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200" data-testid="mobile-menu">
            {navigation.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setIsMenuOpen(false)}
                className={`block py-3 px-4 text-base font-medium transition-colors ${
                  isActive(item.path) ? 'text-[#356C8A] bg-[#E8F2F7]' : 'text-gray-700 hover:bg-[#E8F2F7]'
                }`}
                data-testid={`mobile-nav-link-${item.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;